import { addNumericPadding } from "./rmo/add-numeric-padding";
import { changeFileInputListener } from "./rmo/change-file-listener";
import { changeMultipleAttributesOfInputs } from "./rmo/change-multiple-attributes";
import { fileSelectorFunctionality } from "./rmo/file-selector-functionality";
import { getDataFromUploadedFile } from "./rmo/get-base64-data-from-file";
import { getFormattedDate, getFormattedDateYYYMMDD, getMoFormDataTransformed } from "./rmo/get-mo-data-transformed";
import { setDatePickers } from "./rmo/set-date-picker";
import { copyFromMo } from "./rmo/copy-from-mo.js";
import { addressAttachToLocationFields } from "./rmo/address-attach-rmo.js";
import { codeTransactionData } from './country-code-istransactional-v2.js';
import { inputRMOValidation } from "./rmo/rmo-input-validations.js";

const moneyOrderEl = document.querySelector('#rmo-money-order');
const contactInfoElement = document.querySelector('#contact-information');
const wuProgressBarParent = document.querySelector('.wu-container-progressbar')
const reviewSubmitEl = document.querySelector('#review-submit-mo')
const payOutInfoElement = document.querySelector('#payout-information')

if(moneyOrderEl || contactInfoElement || reviewSubmitEl || payOutInfoElement) {
    const contactInfoStateDropdownEl = contactInfoElement.querySelector('#state-dropdown-ul')
    const contactInfoPhoneNumberEl = contactInfoElement.querySelector('#contact-phone-number')
    const contactInfoFlagCode = contactInfoElement.querySelector('.country-code-flag')
    const contactInfoCountryDropdownEl = contactInfoElement.querySelector('#country-dropdown-contact')
    const contactInfoElementContinueBtn = document.querySelector("#contactInfoContinueBtn")
    const contactInfoCountryCodeUlDropDown = document.querySelector("#country-code-ul-dropdown")
    const contactInfoCountryCodeInputDiv = document.querySelector("#country-code-input-div")
    const btnCollapseMoRefundInstruction = contactInfoElement.querySelector('#btn-money-order-instruction')
    const searchCountry = contactInfoElement?.querySelector("#search-country")
    const inputCountryCode = document.querySelector("#country-dd")
    const repeaterContactInfoParent = contactInfoElement.querySelector('.repeater-contact-info-parent')
    const repeaterContactInfo = repeaterContactInfoParent.querySelector('.repeater-contact-info')
    const addMOButon = moneyOrderEl.querySelector('#add-another-mo')
    const repeaaterMoParent = moneyOrderEl.querySelector('.repeater-mo-parent')
    const wuProgressBar = wuProgressBarParent.querySelectorAll('.wu-progress-bar-gamma')
    const repeaterMo = repeaaterMoParent.querySelector('.repeater-mo')
    const repeaterMoHtml = repeaterMo.innerHTML
    const totalValEl = moneyOrderEl.querySelectorAll('.total-amount')
    const collpasedMo = repeaaterMoParent.querySelector(".collpase-mo")
    const fileSelectors = moneyOrderEl.querySelectorAll('.file-selectors')
    const stateDropdownEl = moneyOrderEl.querySelector('#state-dropdown-ul')
    const countryDropdownInputEl = moneyOrderEl.querySelector('#country-dropdown')
    const backMoButton = moneyOrderEl.querySelector('#back-rmo-button')
    const continueMoButton = moneyOrderEl.querySelector('#continue-mo-button')
    const removeMoConfirmEl = document.querySelector('#removeMoConfirm')
    const deleteMoButtonEl = removeMoConfirmEl.querySelector('#delete-mo-modal')
    const closeMoButtonEl = removeMoConfirmEl.querySelector('#close-mo-modal')
    const progressContact = document.querySelector('#progress-contact')
    const progressMo = document.querySelector('#progress-mo')
    const reviewMoInformation = reviewSubmitEl.querySelector('#review-mo-information')
    const repeaterMoInformation = reviewSubmitEl.querySelector('.mo-information-repeater')
    const cancelReviewButton = reviewSubmitEl.querySelectorAll('.canel-review-rmo')
    const continueRmoButton = reviewSubmitEl.querySelector('#continue-rmo-button')
    const submitMoConfirmation = document.querySelector('#submitMoConfirm')
    const deleteRmoModal = submitMoConfirmation.querySelector('#delete-rmo-modal')
    const currentDateEl = reviewSubmitEl.querySelector('.current-date')
    const dopEl = moneyOrderEl.querySelector('#wu-input-date-purchase');
    const humanKeyEL = document.querySelector("#humanKey");
    const dopIconEl = moneyOrderEl.querySelector('#dop-icon-el')
    const rmoConsent = reviewSubmitEl.querySelector('#rmo-consent')
    const rmoSignature = reviewSubmitEl.querySelector('#rmo-signature')
    const payoutInfoContinue = payOutInfoElement.querySelector('#payout-info-continue')
    const payoutInfoBack = payOutInfoElement.querySelector('#payout-info-back')
    const reviewSubmitForm = reviewSubmitEl.querySelector("#review-submit-final")
    const progressPayout = reviewSubmitEl.querySelector("#progress-payout");
    const payoutModeReviewEl = reviewSubmitEl.querySelector(".payout-mode")
    const payoutAddressView = payOutInfoElement.querySelector("#payout-address-view")
    const payOutFirstCardHeadingDiv = payOutInfoElement.querySelector(".div-first-card-heading")
    const payOutSecondCardHeadingDiv = payOutInfoElement.querySelector(".div-second-card-heading")
    const payoutPencilContact = payOutInfoElement.querySelector("#payout-pencil-contact")
    const payOutSecondcardHeading = payOutInfoElement.querySelector("#secondcardheading")
    const payOutFirstcardHeading = payOutInfoElement.querySelector("#firstcardheading")
    const payoutMailingAddressEL = payOutInfoElement.querySelector("#payout-mailing-address")
    const contactForm = contactInfoElement.querySelector('#contact-form')
    const moFormEl = moneyOrderEl.querySelector("#mo-form")
    const moneyOrderDisclaimer = contactInfoElement.querySelector('.mo-disclaimer')
    const moRefundInstructionElement = contactInfoElement.querySelector('.collpase-mo-refund-instruction')
    const dateChangedErrorEl = reviewSubmitEl.querySelector('#date-changed-error')
    const dateLabelData = reviewSubmitEl.querySelector('#date-label-data')
    const reviewPickupTextEl = reviewSubmitEl.querySelector("#review-pickup-text")
    const cancelMoConfirm = document.getElementById("cancelMoConfirm");
    const noContinueButton = cancelMoConfirm.querySelector('#no-continue-button');
    const refreshButtonEl = cancelMoConfirm.querySelector("#refresh-button");
    const moFiveError = moneyOrderEl.querySelector("#five-mo-error");
    const simpleHeader = document.querySelector('#simpleHeader');
    
    const customerEventId = contactInfoElementContinueBtn.getAttribute('amplitude-page-id')
    const moneyOrderEventId = continueMoButton.getAttribute('amplitude-page-id')
    const payoutEventId = payoutInfoContinue.getAttribute('amplitude-page-id')
    const confirmEventId = continueRmoButton.getAttribute('amplitude-page-id')

    const moNumbers = []
    const moStateKey = { ...USAStates, ...CanadaStates };
    
    moFiveError.querySelector('button').addEventListener('click', () => {
        moFiveError.classList.add('d-none')
        moFiveError.classList.remove("d-flex")
    })

    
    contactInfoPhoneNumberEl.addEventListener('input', function (e) {
        if(contactInfoFlagCode.classList.contains('us')){
            let formattedNum = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            e.target.value = !formattedNum[2] ? formattedNum[1] : '(' + formattedNum[1] + ') ' + formattedNum[2] + (formattedNum[3] ? '-' + formattedNum[3] : '');
            }
    });
    
    
    const ContactInfoInputs = contactInfoElement.querySelectorAll("input");
    Array.from(ContactInfoInputs).forEach((el) => {
      if (el.value) el.setAttribute("value", el.value);
      const elParentDropdown = el.closest(".wu-input.wuds-dropdown");
      if (elParentDropdown) {
        const liElements = elParentDropdown.querySelectorAll("li") || [];
        let foundMatch = false;
        Array.from(liElements).forEach((li) => {
          if (li.innerText.toLowerCase() === el.value?.toLowerCase()) {
            li.click();
            foundMatch = true;
          } else {
            li.classList.remove("d-none");
          }
        });
        if (!foundMatch) el.value = "";
      }
    });

    const inputFocusEvent = (parentEl) => {
        const inputs = parentEl.querySelectorAll("input:not([type=file]):not([type=checkbox]):not(.input-dropdown):not(.address-lookup)");
        Array.from(inputs).forEach((inputEl) => {
            inputEl.addEventListener('focus', () => {
                inputEl.click()
            })
        })
    }

    moFormEl?.addEventListener('submit', (e) => {
        e.preventDefault()
    })

    inputFocusEvent(document)

    if(inputCountryCode) {
        inputCountryCode.addEventListener('click', (e) => {
            contactInfoCountryCodeInputDiv?.classList?.remove('d-flex')
        })
        inputCountryCode.addEventListener('input', (e) => {
          contactInfoCountryCodeInputDiv?.classList?.remove('d-flex')
          let value = e.target.value;
          let lis = contactInfoCountryCodeUlDropDown.querySelectorAll('li')
          Array.from(lis).forEach((li) => {
            if(li.innerText === ' ') {
            } else if (li.innerText.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
              li.classList.remove('d-none')
            } else {
              li.classList.add('d-none')
            }
          })
        })
      }

      progressPayout?.addEventListener('click', (eventObj) => {
        progressMoSpecific(2, eventObj);
      })

      contactInfoCountryCodeUlDropDown && contactInfoCountryCodeUlDropDown.addEventListener('click', (e) => {
          contactInfoCountryCodeInputDiv?.classList?.remove('d-flex')
        })
        contactInfoCountryCodeInputDiv && contactInfoCountryCodeInputDiv.addEventListener('click', (e) => {
          contactInfoCountryCodeInputDiv?.classList?.remove('d-flex')
        })

    if(contactInfoCountryCodeUlDropDown) {
        codeTransactionData.forEach((obj) => {
          let fragment = document.createDocumentFragment();
          let li = document.createElement('li');
          li.className = `wuds-dropdown__items b-flag-select__item `
          let countryNameEL = document.createElement('span')
          countryNameEL.className = `wuds-dropdown__item-text`
          countryNameEL.innerText = `${obj.country} (+${obj.code})`
          let icon = document.createElement("i");
          icon.className = `wu-flag ${obj.iso.toLowerCase()} wu-flagSize--S`;
          li.setAttribute('data-value', `+${obj.code}`)
          li.appendChild(icon);
          li.appendChild(countryNameEL)
          fragment.appendChild(li)
          contactInfoCountryCodeUlDropDown.appendChild(fragment)
          li.addEventListener('mousedown', (e) => {
            inputCountryCode.value = `+${obj.code}`
            inputCountryCode.setAttribute('value', inputCountryCode.value)
            inputCountryCode.setAttribute('data-value', inputCountryCode.value)
          })
        })
      }

    const openCloseMoRefundInstruction = (event) => {
                    event.preventDefault()
                    event.stopPropagation()
                    if (moneyOrderDisclaimer.classList.contains('d-none')) {
                        moneyOrderDisclaimer.classList.remove('d-none')
                        moRefundInstructionElement.querySelector('.plus').classList.add('d-none')
                        moRefundInstructionElement.querySelector('.minus').classList.remove('d-none')
                    } else {
                        moneyOrderDisclaimer.classList.add('d-none')
                        moRefundInstructionElement.querySelector('.minus').classList.add('d-none')
                        moRefundInstructionElement.querySelector('.plus').classList.remove('d-none')
                    }
                }
                
    btnCollapseMoRefundInstruction.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        openCloseMoRefundInstruction(e);
    })


    contactInfoElementContinueBtn?.removeAttribute('disabled');

    payoutPencilContact?.addEventListener('click', (eventObj) => {
        progressMoSpecific(0, eventObj);
        contactInfoElement.querySelector("contact-address").focus()
    })

    payOutFirstcardHeading?.addEventListener("click", () => {
        payOutFirstCardHeadingDiv?.classList?.add("bdr-color-blue");
        payOutSecondCardHeadingDiv?.classList?.remove("bdr-color-blue");
        payoutAddressView?.classList.add("d-none");
    });

    const setPayoutData = () => {
        const contactFormData = new FormData(contactForm)
        let dataContactStateKey = findStateKey(contactFormData.get('mo-state'))
        if(payoutMailingAddressEL) payoutMailingAddressEL.innerHTML = `${contactFormData.get('address')}, ${contactFormData.get('apartment-number')}<br>${contactFormData.get('city')},${dataContactStateKey?.toUpperCase()}<br>${contactFormData.get('zip-code')}, ${contactFormData.get("country")}`
    }
    payOutSecondcardHeading?.addEventListener('click', () => {
        payOutFirstCardHeadingDiv?.classList?.remove("bdr-color-blue");
        payOutSecondCardHeadingDiv?.classList?.add("bdr-color-blue");
        payoutAddressView.classList.remove("d-none")
        setPayoutData()
    })

    const focusInputOnDopClick = (dopIconEl) => {
        dopIconEl.addEventListener('click', (e) => {
            e.preventDefault()
            e.target.closest('.wu-input--bordered').querySelector('input').focus()
        })
    }

    const validateReviewSubmitContinue = (isRmoConsentChecked, rmoSignatureValue) => {
        
        if(humanKeyEL.value && isRmoConsentChecked && rmoSignatureValue) continueRmoButton.removeAttribute('disabled')
        else continueRmoButton.setAttribute('disabled', true)
    }

    document.addEventListener('captchaSuccessEvent' , () => {
        validateReviewSubmitContinue(rmoConsent.checked, rmoSignature.value)
    })

    rmoConsent.addEventListener('change', (e) => {
        validateReviewSubmitContinue(e.target.checked, rmoSignature.value)
    })

    rmoSignature.addEventListener('input', (e) => {
        rmoSignature.setAttribute('value', rmoSignature.value)
        validateReviewSubmitContinue(rmoConsent.checked, rmoSignature.value)
    })

    focusInputOnDopClick(dopIconEl)

    deleteRmoModal.addEventListener('click', () => window.location.reload())

    noContinueButton.addEventListener('click', () => {
        toggleClass(cancelMoConfirm, "d-flex", "d-none");
    })

    refreshButtonEl.addEventListener("click", () => window.location.reload());

    payoutInfoContinue.addEventListener('click', (eventObj) => {
        progressMoSpecific(3, eventObj);
    })

    payoutInfoBack.addEventListener("click", (eventObj) => {
      progressMoSpecific(1, eventObj);
    });

    const getCountrySlug = (value) => {
        const countryEl = document.querySelector(`[data-value="${value}"]`)
        return countryEl?.getAttribute('data-slug')
    }

    const getCountryName = (name) => {
        return name?.toUpperCase() === 'UNITED STATES OF AMERICA' ? 'United States' : name
    }

    const hideShowDateError = (show, e) => {
        if(show) {
            dateChangedErrorEl?.classList.remove("d-none");
            dateLabelData?.classList.add("text-red");
            e?.stopPropagation();
        } else {
            dateChangedErrorEl?.classList.add("d-none");
            dateLabelData?.classList.remove("text-red");
        }
    }

    const getFormattedAmount = (amount) => {
        if(amount < 10) {
            return `00${amount}`
        } else if(amount < 100) {
            return `0${amount}`
        }
        return amount
    }

    const postalCodeForRmoApi = (zipCodeText, countrySlug) => {
        if(countrySlug?.toUpperCase() === 'CA' && !zipCodeText.includes(" ")) {
            return `${zipCodeText.substring(0,3)} ${zipCodeText.substring(3,6)}`
        }
        return zipCodeText
    }

    continueRmoButton.addEventListener('click', async (e) => {
        e.preventDefault()
        let isDateError = currentDateEl.innerHTML !== getFormattedDate();
        hideShowDateError(isDateError);
        if (isDateError) return;
        let moDataForRequest = []
        let moFormData = await getMoFormDataTransformed(moneyOrderEl, currentDateEl)
        for(let i=0;i<moFormData.length;i++) {
            const data = moFormData[i]
            const moCopyAddress = data[`mo-copy-address`]
            let fileArray = [data['front-view-file']]
            if(data['additional-file']?.size !== 0) {
                fileArray.push(data['additional-file'])
            } else if(data['additional-file-mobile']?.size !== 0){
                fileArray.push(data['additional-file-mobile'])
            }
            let filesArray = await getDataFromUploadedFile(fileArray)
            moDataForRequest.push({
              payAmount: getFormattedAmount(Math.round(data["mo-amount"] * 100)),
              // "fee": "", to check
              serialNumber: data["mo-number"],
              reason: data["mo-reason"],
              payTo: data["mo-payable-to"],
              date: getFormattedDateYYYMMDD(data["mo-date-purchase"]),
              // "time": "", to check
              // "status": "",  to check
              // "statusUpdatedOn": "",  to check
              // "numberOfCheck": "", to check
              documents: filesArray,
              address: moCopyAddress && moCopyAddress === 'on' ? moDataForRequest[0]?.address : {
                addressLine1: data["mo-location-name"],
                city: data["mo-city"],
                stateCode: findStateKey(data["mo-state"]),
                stateName: data["mo-state"],
                countryName: getCountryName(data["mo-country"]),
                countryCode: getCountrySlug(data["mo-country"]),
                postalCode: ""
                // type: "PRIMARY",
              },
            }); 
        }
        
        //call API here
        const contactFormData = new FormData(contactInfoElement.querySelector('#contact-form'))
        const reviewSubmitFormData = new FormData(reviewSubmitForm)
        let url = location.host.startsWith('www3') ? `https://agent-services-qa.useast1.digitalnonprod.awswuintranet.net/rmosvc/v1/rmo/refund/request` : `/rmosvc/v1/rmo/refund/request`
        const externalRefId = `rmo-refund-${randomStringGenerator(0x100000)}`
        const reqPayload = {
          security: {
            captchaVerification: humanKeyEL.value,
          },
          customer: {
            name: {
              first: contactFormData.get("first-name"),
              middle: null,
              last: contactFormData.get("last-name"),
              secondLast: null,
            },
            address: {
              addressLine1: contactFormData.get("address"),
              city: contactFormData.get("city"),
              stateCode: findStateKey(contactFormData.get("mo-state")),
              stateName: contactFormData.get("mo-state"),
              countryCode: getCountrySlug(contactFormData.get("country")),
              countryName: getCountryName(contactFormData.get("country")),
              postalCode: postalCodeForRmoApi(contactFormData.get("zip-code"), getCountrySlug(contactFormData.get("country"))),
              type: "PRIMARY",
              apartmentNumber: contactFormData.get("apartment-number")
            },
            phoneNumber: [
              {
                countryCode: contactFormData
                  .get("country-phone-code")
                  ?.replace("+", ""),
                number: contactFormData.get("phone")?.replace(/\D+/g, ''),
                type: "CELL_PHONE",
              },
            ],
            email: contactFormData.get("email"),
          },
          refundMethod:
            payoutModeReviewEl.innerHTML === "Cash pickup"
              ? "Cash Pickup"
              : "Check by Mail",
          consent: "Allowed",
          signature: reviewSubmitFormData.get("rmo-signature"),
          signedDate: getFormattedDateYYYMMDD(currentDateEl.innerHTML),
        //   moneyOrders: moDataForRequest,
        };
        let firstRequest = moDataForRequest.slice(0);
        let secondLotOfRequest = moDataForRequest.slice(1);
        const moRequestApiCall = async(data, index) => {
            reqPayload["moneyOrders"] = [data]
                reqPayload["isOfflineCase"] = index !== 0;
                const requestOptions = {
                    method: "POST",
                    headers: {
                        "accept": "application/json, text/plain, */*",
                        "Content-Type": "application/json",
                        "accept-language": "en-US,en;q=0.9",
                        "x-wu-correlationId": `rmo-${randomStringGenerator(0x1000000)}-${randomStringGenerator(0x100)}`,
                        "x-wu-externalRefId": externalRefId
                    },
                    body: JSON.stringify(reqPayload)
                };
                return fetchApiWu(url, requestOptions, "rmo-api", true, true);
        }
        try {
            await moRequestApiCall(firstRequest[0], 0);
            await Promise.allSettled(secondLotOfRequest.map((data, index) => moRequestApiCall(data, index+1)));
        } catch(e) {
            console.error(e)
        } finally {
            toggleClass(submitMoConfirmation, 'd-none', 'd-flex')
            hideSpinnerMain()
        }
    })


    Array.from(cancelReviewButton).forEach(el => {
        el.addEventListener('click', () => {
            toggleClass(cancelMoConfirm, 'd-none', 'd-flex')
        })
    })

    progressContact.addEventListener('click', (e) => progressMoSpecific(0))

    progressMo.addEventListener('click', (e) => progressMoSpecific(1))

    backMoButton.addEventListener('click', (e) => progressMoSpecific(0))

    const removeMoFunctionality = (element) => {
        element.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()
            removeMoConfirmEl.classList.remove('d-none')
            toggleClass(removeMoConfirmEl,'d-none', 'd-flex')
            addMOButon.classList.remove('bk-grey-01')
            addMOButon.classList.add("wu-button_tertiatry--blue","wu-button_tertiatry--blue--hover")
            addMOButon.removeAttribute('disabled')
            addMOButon.removeAttribute('style')
            moFiveError.classList.add('d-none')
            moFiveError.classList.remove("d-flex")
            removeMoConfirmEl.querySelector('[id^="delete-mo-modal"]').setAttribute('data-delete-id',e.target.id.replace('remove-mo-button-',''))
        })
    }

    deleteMoButtonEl.addEventListener('click', (e) => {
        const dataDeleteId = e.target.getAttribute('data-delete-id')
        const repeaterMoIndividual =  moneyOrderEl.querySelectorAll('.repeater-mo-individual')
        repeaterMoIndividual[dataDeleteId-1]?.remove()
        const subHeadingMoEls = moneyOrderEl.querySelectorAll('.repeater-mo-individual .subheading')
        let headingTextFirst = subHeadingMoEls[0].innerHTML
        Array.from(subHeadingMoEls).forEach((el, index) => {
            el.closest('.repeater-mo-individual').querySelector("[id^=remove-mo-button]").setAttribute("id", `remove-mo-button-${index+1}`)
            el.innerHTML = headingTextFirst.replace("01", addNumericPadding(index+1))
        })
        repeaterMoIndividual[dataDeleteId-2].querySelector('[id^=wu-input-mo-number]').focus()
        toggleClass(removeMoConfirmEl,'d-flex', 'd-none')
        totalValCalculate()
    })

    closeMoButtonEl.addEventListener('click', () => {
        toggleClass(removeMoConfirmEl,'d-flex', 'd-none')
    })

    const moFormSubmitValidation = () => {
        let errorDropdown = drodpownValidationsEvent(moneyOrderEl)
        let errorInputs = inputValidationsEvents(moneyOrderEl, true)
        let errorFiles = filesValidation()
        const firstErrorEl = moneyOrderEl.querySelector('.wu-input.wu-input--error') || moneyOrderEl.querySelector('.file-selectors.text-red')
        firstErrorEl?.scrollIntoView()
        if(errorDropdown || errorInputs || errorFiles) return true
    }

    continueMoButton.addEventListener('click', (eventObj) => {
        progressMoSpecific(2, eventObj);

    })

    const contactInfoValidation = () => {
        contactInfoCountryCodeInputDiv?.classList?.remove('d-flex')
        let errorDropdown = drodpownValidationsEvent(contactInfoElement)
        let errorInputs = inputValidationsEvents(contactInfoElement, true)
        if(errorDropdown || errorInputs) return true
    }

    contactInfoElementContinueBtn.addEventListener('click', (e) => {
        e.preventDefault()
         contactInfoCountryCodeInputDiv?.classList?.remove('d-flex')
        if(contactInfoValidation()){
            window.rmoFormData.changeProgressBar(0)
            return 
        }else{
            progressMoSpecific(1)
        }    
    })
    dropdownFeature(contactInfoElement)
    dropdownFeature(moneyOrderEl)

    const filesValidation = () => {
        const fileTypesEL = document.querySelectorAll('input[type=file]:not([id^=additional-file])')
        let error = false
        Array.from(fileTypesEL).forEach((fileEl) => {
            if(fileEl.files.length === 0) {
                error =true
                showFileValidationMessage(fileEl, 'text-file-error')
            } else {
                hideFileValidationMessage(fileEl)
            }
        })
        return error
    }

    setDatePickers(dopEl)
    stateFeature(contactInfoCountryDropdownEl,contactInfoStateDropdownEl)
    stateFeature(countryDropdownInputEl, stateDropdownEl)     

    const openCloseMo = (event) => {
        event.stopPropagation()
        const individualEl =  event.target.closest('.repeater-mo-individual')
        const rowEl =individualEl.querySelector('.row')
        if(rowEl.classList.contains('d-none')) {
            rowEl.classList.remove('d-none')
            individualEl.querySelector('.plus').classList.add('d-none')
            individualEl.querySelector('.minus').classList.remove('d-none')
            individualEl.querySelector('.amount-updated').classList.add('d-none')
        } else {
            rowEl.classList.add('d-none')
            individualEl.querySelector('.plus').classList.remove('d-none')
            individualEl.querySelector('.minus').classList.add('d-none')
            individualEl.querySelector('.amount-updated').classList.remove('d-none')
        }
    }

    const inputValidationsEvents = (parentEl, validateOnSubmit) => {
        let inputs = parentEl.querySelectorAll(
          "input:not([id^=country-dd]):not([id^=wu-input-payable-to]):not([id^=additional-file]):not([id^=back-view]):not([id^=front-view]):not([id^=country-dropdown]):not([id^=reason-refund-dropdown]):not([id^=state-dropdown]):not([id^=contact-apartment-number])"
        );
        let error = false;
        inputs = Array.from(inputs).filter((el) => {
            const individualMoLocationCheckbox = el.closest('.repeater-mo-individual') ? el.closest('.repeater-mo-individual').querySelector('[id^=copy-from-mo]') : null
            if(individualMoLocationCheckbox && individualMoLocationCheckbox.checked) {
                return !(el.id.includes('wu-input-location-name') || el.id.includes('wu-input-city'))
            } else {
                return true
            }
        })
        Array.from(inputs).forEach((inputEl) => {
            if(validateOnSubmit) {
                error = inputRMOValidation(inputEl, moNumbers) || error;
            } else {
                inputEl.addEventListener('blur', (e) => {
                    error = inputRMOValidation(inputEl, moNumbers) || error;
                })
                inputEl.addEventListener('input', debounceGeneric((e) => {
                    error = inputRMOValidation(inputEl, moNumbers) || error
                },1000))
                inputEl.addEventListener('keydown', (e) => {
                    if((inputEl.id.indexOf('mo-number') !== -1)){
                        if(e.keyCode === 189 || e.keyCode === 40 || e.keyCode === 38) {
                            e.preventDefault()
                            e.stopPropagation()
                        }
                    }
                })
            }
        })
        return error
    }

    const drodpownValidationsEvent = (elements) => {
        let dropdownEls = elements.querySelectorAll('.wuds-dropdown')
        let isError = false;
        Array.from(dropdownEls).forEach((dropdownEl) => {
            let spanVal = dropdownEl.querySelector('span.b-flag-select__value')
            if(spanVal?.innerHTML === '') {
                showValidationMessage(spanVal)
                dropdownEl.querySelector(".wu-input_flag-currency")?.setAttribute('style', 'top: 40%')
                isError = true;
                const repeaterMoIndividual = dropdownEl.closest('.repeater-mo-individual')
                if(repeaterMoIndividual && repeaterMoIndividual.querySelector('.row')?.classList.contains('d-none')) {
                    repeaterMoIndividual.querySelector('.subheading').click()
                }
            } else {
                dropdownEl.classList.remove('wu-input--error')
                spanVal && hideValidationMessage(spanVal)
            }
        })
        return isError
    }
    inputValidationsEvents(contactInfoElement)
    inputValidationsEvents(moneyOrderEl)


    const totalValCalculate = () => {
        const allAmountUpdated = moneyOrderEl.querySelectorAll(
          '[name*="mo-amount"]'
        );
        const totalValue = Array.from(allAmountUpdated).reduce((acc, el) => {
          return acc + (el.value ? parseFloat(el.value) : 0);
        }, 0);
        totalValEl[0].innerText = `$${parseFloat(totalValue).toFixed(2)}`;
        totalValEl[1].innerText = `$${parseFloat(totalValue).toFixed(2)}`;
    }
    
    const amountEventListener = (target, parentEl) => {
        parentEl.querySelector('.amount-updated').innerText = `${target.value ? parseFloat(target.value).toFixed(2) : '0.00'}`
        totalValCalculate()   
    }

    const inputEventListener = (parentEl) => {
        const childEls = parentEl.querySelectorAll('input')
        Array.from(childEls).forEach((childEl) => {
            childEl.addEventListener('input', (el) => {
                el.target.setAttribute('value', el.target.value)
                el.target.id?.includes('wu-input-mo-amount') && amountEventListener(el.target, parentEl)
            })
        })
    }



    addMOButon.addEventListener('click', (e) => {
        e.preventDefault()
        let individualMoEls =  moneyOrderEl.querySelectorAll('.repeater-mo-individual')
        if(individualMoEls.length === 5) {
            return;
        } else if (individualMoEls.length === 4) {
            addMOButon.classList.add("bk-grey-01")
            addMOButon.classList.remove("wu-button_tertiatry--blue","wu-button_tertiatry--blue--hover")
            addMOButon.setAttribute('disabled', true)
            addMOButon.setAttribute("style", "pointer-events: none;text-decoration: none")
            toggleClass(moFiveError, "d-none", "d-flex")
        }
          repeaterMo.insertAdjacentHTML("beforeend", repeaterMoHtml);
        const subHeadingsEl = moneyOrderEl.querySelectorAll('.subheading')
        let text = subHeadingsEl[0].innerHTML
        individualMoEls =  moneyOrderEl.querySelectorAll('.repeater-mo-individual')
        let moNumber = individualMoEls.length-1
        const latestAddedIndividualMo = individualMoEls[moNumber]
        latestAddedIndividualMo.querySelector(".collpase-mo").addEventListener('click', openCloseMo)
        latestAddedIndividualMo.querySelector('.subheading').innerHTML = text.replace('01',addNumericPadding(moNumber +1))
        changeMultipleAttributesOfInputs(moNumber+1, latestAddedIndividualMo)
        inputEventListener(latestAddedIndividualMo)
        addressAttachToLocationFields(latestAddedIndividualMo)
        fileSelectorFunctionality(latestAddedIndividualMo.querySelectorAll('.file-selectors'))
        changeFileInputListener(latestAddedIndividualMo.querySelector(`#files-upload-${moNumber+1}`))
        toggleClass(latestAddedIndividualMo.querySelector('.copy-address-field'),'d-none', 'd-flex')
        latestAddedIndividualMo.querySelector('.remove-mo').classList.remove('d-none')
        dropdownFeature(latestAddedIndividualMo)
        stateFeature(latestAddedIndividualMo.querySelector(`#country-dropdown-${moNumber+1}`), latestAddedIndividualMo.querySelector(`#state-dropdown-ul-${moNumber+1}`))
        removeMoFunctionality(latestAddedIndividualMo.querySelector('[id^=remove-mo-button]'))
        copyFromMo(latestAddedIndividualMo.querySelector('[id^="copy-from-mo"]'))
        inputValidationsEvents(latestAddedIndividualMo)
        setDatePickers(latestAddedIndividualMo.querySelector('[id^=wu-input-date-purchase]'))
        inputFocusEvent(latestAddedIndividualMo);
    })

    fileSelectorFunctionality(fileSelectors)
    changeFileInputListener(moneyOrderEl.querySelector('#files-upload'))

    inputEventListener(repeaterContactInfo)
    inputEventListener(repeaterMo)

    addressAttachToLocationFields(contactInfoElement)
    addressAttachToLocationFields(moneyOrderEl)

    collpasedMo.addEventListener('click', openCloseMo)

    const rmoProgess = (showContact, showMoneyOrder, showReview, showPayoutInfo) => {
        showHideElements(contactInfoElement, showContact)
        showHideElements(moneyOrderEl, showMoneyOrder)
        showHideElements(reviewSubmitEl, showReview)
        showHideElements(payOutInfoElement, showPayoutInfo)
        if(showReview) {
            wuProgressBarParent.classList.add('bk-grey-01')
        } else {
            wuProgressBarParent.classList.remove('bk-grey-01')
        }
    }

    const validateContactAndMo = () => {
        if (contactInfoValidation()) {
          window.rmoFormData.changeProgressBar(0);
          return true;
        }
        if (moFormSubmitValidation()) {
          window.rmoFormData.changeProgressBar(1);
          return true;
        }
    }

    const progressMoSpecific = (count, eventObject) => {
        if(eventObject) eventObject.preventDefault()
        
        if (count === 0) {
          rmoProgess(true, false, false, false);
          if(simpleHeader.classList.contains('d-none')){
            simpleHeader.classList.remove('d-none');
            simpleHeader.classList.add('d-flex');
          }
          triggerAmplitudePageEvent(customerEventId)
        } else if (count === 1) {
            if (contactInfoValidation()) {
              window.rmoFormData.changeProgressBar(0);
              return;
            }
            rmoProgess(false, true, false, false);
            if(simpleHeader.classList.contains('d-flex')){
                simpleHeader.classList.remove('d-flex');
                simpleHeader.classList.add('d-none');
              }  
            triggerAmplitudePageEvent(moneyOrderEventId)
        } else if (count === 2) {
            if(validateContactAndMo()) return
            setPayoutData()
            rmoProgess(false, false, false, true);
            if(simpleHeader.classList.contains('d-flex')){
                simpleHeader.classList.remove('d-flex');
                simpleHeader.classList.add('d-none');
              }
            triggerAmplitudePageEvent(payoutEventId)
        } else if (count === 3) {
            if (validateContactAndMo()) return;
            rmoProgess(false, false, true, false);
            if(simpleHeader.classList.contains('d-flex')){
                simpleHeader.classList.remove('d-flex');
                simpleHeader.classList.add('d-none');
              }
            triggerAmplitudePageEvent(confirmEventId)
            reviewSubmitDataAggregate();
        }
        window.rmoFormData.changeProgressBar(count)
        scrollTo(0,0)
    }

    const findStateKey = (value) => {
        let dataKey = ''
        for(let key in moStateKey) {
            if(moStateKey[key] === value) {
                dataKey = key
            }
        }
        return dataKey
    }
    
    reviewSubmitForm.addEventListener('submit', (e) => {
        e.preventDefault()
    })


    const reviewSubmitDataAggregate = () => {
        hideShowDateError();
        currentDateEl.innerHTML = getFormattedDate()
        let dataMo = getMoFormDataTransformed(moneyOrderEl, currentDateEl)
        
        const payOutDataForm = new FormData(payOutInfoElement.querySelector('#payout-info-form'))
        const payOutMode = payOutDataForm.get("payoutOption")
        const payoutRadioInput = payOutInfoElement.querySelector(`input[value=${payOutMode}]`)
        const pickupEl = reviewSubmitEl.querySelector('.pickup-data') 
        payoutModeReviewEl.innerHTML = payoutRadioInput.getAttribute('data-payout-text')
        const contactFormData = new FormData(contactForm)
        
        const outerHtmlMoInformation = repeaterMoInformation.outerHTML
        const totalReviewEl =  reviewSubmitEl.querySelector('#total-review')
        totalReviewEl.querySelector('.value').innerHTML = `${moneyOrderEl.querySelector('.total-amount').innerHTML}`
        let repeatersMo = reviewMoInformation.querySelectorAll('.mo-information-repeater')
        Array.from(repeatersMo).forEach((el) => {
            el.remove()
        })
        dataMo.forEach((data) => {
            totalReviewEl.insertAdjacentHTML('beforebegin', outerHtmlMoInformation)
        })
        repeatersMo = reviewMoInformation.querySelectorAll('.mo-information-repeater')
        dataMo.forEach((data, index) => {
            const setInnerHtml = (el, html) => el.innerHTML = html ? html : ''
            const numberEl = repeatersMo[index].querySelector('.review-mo-number')
            setInnerHtml(numberEl, data['mo-number'])
            const amountEl = repeatersMo[index].querySelector('.review-mo-amount')
            setInnerHtml(amountEl, `$${data['mo-amount']}`)
            const dopEl = repeatersMo[index].querySelector('.review-mo-dop')
            setInnerHtml(dopEl, data['mo-date-purchase'])
            const payableEl = repeatersMo[index].querySelector('.review-mo-payable')
            setInnerHtml(payableEl, data['mo-payable-to'])
            const reasonEl = repeatersMo[index].querySelector('.review-mo-reason')
            setInnerHtml(reasonEl, data['mo-reason'])
            const locationEl = repeatersMo[index].querySelector('.review-mo-location')
            let dataMoStateKey = findStateKey(data['mo-copy-address'] !== 'on' ? data['mo-state'] : dataMo[0]['mo-state'])
            
            setInnerHtml(locationEl, data['mo-copy-address'] !== 'on' ? 
                `${data['mo-location-name']}, ${data['mo-city']}, ${dataMoStateKey?.toUpperCase()}, ${data['mo-country']}` :
                `${dataMo[0]['mo-location-name']}, ${dataMo[0]['mo-city']}, ${dataMoStateKey?.toUpperCase()}, ${dataMo[0]['mo-country']}` )
        })
        
        //contact information
        
        reviewSubmitEl.querySelector('.total-name').innerHTML = `${contactFormData.get('first-name')} ${contactFormData.get('last-name')}`
        reviewSubmitEl.querySelector('.email').innerHTML = `${contactFormData.get('email')}`
        reviewSubmitEl.querySelector('.phone').innerHTML = `${contactFormData.get('country-phone-code')} ${contactFormData.get('phone')}`
        let dataContactStateKey = findStateKey(contactFormData.get('mo-state'))
        const addressContact = `${contactFormData.get('address')}, ${contactFormData.get('apartment-number') ? contactFormData.get('apartment-number') + "," : ''} ${contactFormData.get('city')}, ${dataContactStateKey?.toUpperCase()}, ${contactFormData.get('zip-code')}, ${contactFormData.get("country")}`
        reviewSubmitEl.querySelector(".address").innerHTML = addressContact
        if(payOutMode === 'cash') {
            reviewPickupTextEl.innerHTML = reviewPickupTextEl.getAttribute("data-pickup-text")
            pickupEl.innerHTML = payoutRadioInput.getAttribute("data-pickup-text")
        } else {
            reviewPickupTextEl.innerHTML = reviewPickupTextEl.getAttribute("data-mailing-address")
            pickupEl.innerHTML = addressContact;
        }
    }



    if(wuProgressBar) {

        Array.from(wuProgressBar).forEach((bar, index) => {
            bar.addEventListener('click' , () => {
                progressMoSpecific(index)
            })
        })
    }
}

